export default __webpack_public_path__ + "static/media/gallery_02.bf909677.jpg";